import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import { CampaignsResponse } from '../../../models/campaigns-response';
import { HttpErrorResponse } from '@angular/common/http';
import { Campaign, CampaignStatus, CampaignType } from '../../../models/campaigns-models/campaign';
import { CampaignPayload } from '../../../models/campaigns-models/campaign-payload';
import { CampaignFilters, SortType } from '../../../models/campaigns-models/campaign-filters';
import { ClientTokens } from '../../../models/campaigns-models/client-tokens';
import { MediaPlatformAccount, MediaPlatformType } from '../../../models/campaigns-models/media-platform-account';
import { PlatformValidationRules } from '../../../models/campaigns-models/platform-validation-rules';


export const CampaignsActions = createActionGroup({
  source: 'CAMPAIGNS',
  events: {
    getCampaigns: emptyProps(),
    getCampaignsSuccess: props<{ campaignsResponse: CampaignsResponse }>(),
    getCampaignsError: props<{
      error: HttpErrorResponse,
      userFriendlyMessage: string,
    }>(),
    getValidationRules: emptyProps(),
    getValidationRulesSuccess: props<{ validationRules: PlatformValidationRules[] }>(),
    getValidationRulesError: props<{
      error: HttpErrorResponse,
      userFriendlyMessage: string,
    }>(),
    upsertCampaign: props<{ campaignPayload: CampaignPayload, files: File[], id?: string }>(),
    upsertCampaignSuccess: props<{ campaign: Campaign }>(),
    upsertCampaignError: props<{
      error: HttpErrorResponse,
      userFriendlyMessage: string,
    }>(),
    deleteCampaign: props<{ campaignId: string }>(),
    deleteCampaignSuccess: props<{ campaignId: string }>(),
    deleteCampaignError: props<{
      error: HttpErrorResponse,
      userFriendlyMessage: string,
      campaignId: string,
    }>(),
    archiveCampaign: props<{ campaignId: string }>(),
    archiveCampaignSuccess: props<{ campaign: Campaign }>(),
    archiveCampaignError: props<{
      error: HttpErrorResponse,
      userFriendlyMessage: string,
      campaignId: string
    }>(),
    getClientTokens: emptyProps(),
    getClientTokensSuccess: props<{ clientTokens: ClientTokens }>(),
    getClientTokensError: props<{
      error: HttpErrorResponse,
      userFriendlyMessage: string,
    }>(),
    setClientTokens: props<{ tokensToAdd: number }>(),
    setClientTokensSuccess: props<{ clientTokens: ClientTokens }>(),
    setClientTokensError: props<{
      error: HttpErrorResponse,
      userFriendlyMessage: string,
    }>(),
    // FILTERS
    updateTitleFilter: props<{ title: string }>(),
    updateStatusFilter: props<{ status: CampaignStatus }>(),
    updateTypeFilter: props<{ campaignType: CampaignType }>(),
    updateSortType: props<{ sortType: SortType }>(),
    updateDateRange: props<{ from: string, to: string }>(),
    updateGbpAccountIds: props<{ gbpAccountIds: string[] }>(),
    updateAllFilters: props<{ filters: CampaignFilters }>(),
  },
});

export const MediaPlatformActions = createActionGroup({
  source: 'CAMPAIGNS - Platform',
  events: {
    getPlatforms: emptyProps(),
    getPlatformsSuccess: props<{ platforms: MediaPlatformAccount[] }>(),
    getPlatformsFail: props<{ error: HttpErrorResponse, userFriendlyMessage: string }>(),
    connectPlatform: props<{ platform: MediaPlatformType, frontendRedirectUrl: string }>(),
    connectPlatformSuccess: emptyProps(),
    connectPlatformFail: props<{ error: HttpErrorResponse, userFriendlyMessage: string }>(),
    disconnectPlatform: props<{ id: string }>(),
    disconnectPlatformSuccess: props<{ platform: Partial<MediaPlatformAccount> }>(),
    disconnectPlatformFail: props<{ error: HttpErrorResponse, userFriendlyMessage: string }>(),
  },
});


export const campaignComponentDestroyed = createAction('[CAMPAIGNS] - COMPONENT DESTROYED');
